import { Instance, types } from 'mobx-state-tree';
import { toJS } from 'mobx';

// No `results` here, unlike PollStore. A poll's results are a histogram the
// server computes and publishes; HTML-question results are built in the browser
// from answerMap (groupResponses -> ResponsesTable), because an answer is a v2
// envelope whose per-student summary and score are the point.
export const HTMLQuestionStore = types
  .model('HTMLQuestionStore', {
    answerMap: types.maybeNull(types.map(types.frozen())),
    displayResults: types.boolean,
  })
  .actions((self) => ({
    showResults() {
      self.displayResults = true;
    },
    hideResults() {
      self.displayResults = false;
    },
  }))
  .views((self) => ({
    get answersTOJS() {
      return toJS(self.answerMap);
    },
  }));

export interface IHTMLQuestionStore extends Instance<typeof HTMLQuestionStore> {}
